import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { PreparationMethod, StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import React from 'react';
import { useSelector } from 'react-redux';
import WholePortionOvenDryingPreparationSection from './WholePortionOvenDryingPreparationSection';
import WholePortionPredriedPreparationSection from './WholePortionPredriedPreparationSection';
import WholePortionPretreatmentPreparationSection from './WholePortionPretreatmentPreparationSection';
import WholePortionWetPreparationSection from './WholePortionWetPreparationSection';

let WholePortionPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const stateBeforePreparation: StateOfMaterial = useSelector(
    createWorksheetSelector!('Preparation.StateBeforePreparation')
  );
  const preparationMethod: PreparationMethod = useSelector(createWorksheetSelector!('Preparation.PreparationMethod'));

  //Oven Drying - wet and dry masses are measured, moisture content calculated from wet and dry masses.
  const ovenDrying =
    stateBeforePreparation === StateOfMaterial.Moist && preparationMethod === PreparationMethod.OvenDry;

  //Pre-dried material - dry mass is measured, no wet mass or moisture content test
  const preDriedMaterial = stateBeforePreparation === StateOfMaterial.OvenDry;

  //Wet material - wet mass is measured, moisture content test is performed, dry mass calculated from wet mass and
  //moisture content
  const wetMaterial = stateBeforePreparation === StateOfMaterial.Moist && preparationMethod === PreparationMethod.Moist;

  //Pre-treated material - wet mass measured, water content test performed, pre-treatment performed, dry mass
  //measured as a part of pre-treatment.
  const pretreatedMaterial =
    stateBeforePreparation === StateOfMaterial.Moist && preparationMethod === PreparationMethod.PreTreated;

  return (
    <PageSection heading="Sieve Portion Preparation">
      {ovenDrying && <WholePortionOvenDryingPreparationSection />}
      {preDriedMaterial && <WholePortionPredriedPreparationSection />}
      {wetMaterial && <WholePortionWetPreparationSection />}
      {pretreatedMaterial && <WholePortionPretreatmentPreparationSection />}
    </PageSection>
  );
};
WholePortionPreparationSection = withInjectedProps(WholePortionPreparationSection);

export { WholePortionPreparationSection };
export default WholePortionPreparationSection;
